import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'white';
  size?: 'sm' | 'md' | 'lg';
  children: React.ReactNode;
}
export function Button({
  variant = 'primary',
  size = 'md',
  className = '',
  children,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-medium transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none';
  const variants = {
    primary: 'bg-[#C1694F] text-white hover:bg-[#A6553D] focus:ring-[#C1694F]',
    secondary: 'bg-[#A8B5A0] text-white hover:bg-[#8F9C88] focus:ring-[#A8B5A0]',
    outline: 'border-2 border-[#C1694F] text-[#C1694F] hover:bg-[#C1694F] hover:text-white focus:ring-[#C1694F]',
    white: 'bg-white text-[#2D2D2D] hover:bg-[#FAF8F5] focus:ring-white'
  };
  const sizes = {
    sm: 'h-9 px-4 text-sm',
    md: 'h-11 px-6 text-base',
    lg: 'h-14 px-8 text-lg'
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} {...props} data-id="element-176">
      {children}
    </motion.button>;
}